var map = {
	"./120bpm.ogg": 1402,
	"./150bpm.ogg": 7384,
	"./180bpm.ogg": 9365,
	"./birds_intense.ogg": 4711,
	"./brown-noise.ogg": 106,
	"./drum_mantra.ogg": 3508,
	"./fans.ogg": 8803,
	"./forest.ogg": 2115,
	"./hydraulic.ogg": 3832,
	"./mantra_drum.ogg": 6386,
	"./melodic_scifi.ogg": 7330,
	"./noise.ogg": 7991,
	"./pagoda.ogg": 2925,
	"./pink_noise.wav": 7252,
	"./plates.ogg": 1751,
	"./rain.ogg": 5678,
	"./static.ogg": 9401,
	"./thunder_rain.ogg": 3327,
	"./train.ogg": 6801,
	"./waves.ogg": 7394,
	"./white_noise.ogg": 9130,
	"./wind.ogg": 8761
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6066;